<template>
  <div ref="myChart" style="width: 100%; height: 200px;"></div>
</template>

<script>
import echarts from 'echarts';

export default {
  props: {
    values: {
      type: Array,
      required: true, // 确保 values 是必需的
    },
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.myChart);
      this.setChartOptions();
    },
 setChartOptions() {
  const data = this.values; // 使用 props 中的 values
  const maxValue = Math.max(...data);
  const minValue = Math.min(...data);
  console.log('最大值', maxValue, minValue);

  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: data.map((_, index) => (index + 1).toString()), // 根据 values 的长度生成 x 轴标签
        axisTick: {},
        axisLine: {
          lineStyle: {
            color: 'rgba(127, 132, 139, 1)' // 设置 x 轴线颜色
          }
        },
        axisLabel: {
          color: 'rgba(127, 132, 139, 1)' // 设置 x 轴标签颜色
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: 'rgba(127, 132, 139, 1)' // 设置 y 轴线颜色
          }
        },
        axisLabel: {
          color: 'rgba(127, 132, 139, 1)' // 设置 y 轴标签颜色
        },
        // splitLine: {
        //   lineStyle: {
        //     color: 'rgba(127, 132, 139, 1)' // 设置 y 轴分割线颜色
        //   }
        // }
      }
    ],
    series: [
      {
        name: this.$t('电压'),
        type: 'bar',
        barWidth: '20px',
        data: data.map(value => ({
          value: value,
          itemStyle: {
            color: value == maxValue ? 'rgba(255, 125, 0, 1)' :
                  value == minValue ? 'rgba(14, 197, 192, 1)' :
                  'rgba(25, 190, 107, 1)'
          }
        }))
      }
    ]
  };

  this.chart.setOption(option);
},
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    }
  },
  watch: {
    values: {
      deep: true, // 如果 values 是数组，使用深度监听
      handler(newVal) {
        this.setChartOptions(); // 重新设置图表选项
      }
    }
  }
};
</script>

<style>
/* You can add styles as needed */
</style>
